import { type Component } from "solid-js"
import Footer from "../shared/components/Footer"
import SimpleTopBar from "./SimpleTopBar"
import ThanksHeader from "./ThanksHeader"
import NextSteps from "./NextSteps";

const Thanks: Component = () => {
  return (
    <div class='flex flex-col'>
      <div class='min-h-screen bg-gunmetal flex flex-col'>
        <SimpleTopBar />
        <div class='flex-1 flex flex-col items-center justify-center gap-8 px-4 py-10'>
          <ThanksHeader />
          <NextSteps />
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Thanks
